export default __webpack_public_path__ + "4286816cf0c770679e673974a7c87e7b.svg";